var scope_0 = require('/home/runner/work/docs.humancentricai.org/docs.humancentricai.org/.layouts/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0 )
    